import { number_format } from '@/api/filter';
export const config = {
  data() {
    return {
      columns: [],
      searchParams: {
        orderType: '1',
        dateType: '1'
      }
    };
  },
  methods: {
    getColumns() {
      let statusMap = JSON.parse(localStorage.getItem('dic')).GROUP_POLICY_STATUS;
      let columns = [
        {
          title: '承保时间',
          key: 'issueTime',
          minWidth: 160,
          align: 'center',
          render(h, params) {
            let issueTime = params.row.issueTime && params.row.issueTime.substring(0, 16);
            return <span>{issueTime}</span>;
          }
        },
        {
          title: '保单号/订单号',
          key: 'orderNo',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            return (
              <div>
                <p>{params.row.policyNo}</p>
                <p>{params.row.orderNo}</p>
              </div>
            );
          }
        },
        {
          title: '业务类别',
          key: 'sellType',
          align: 'center',
          slot: 'sellTypeSlot',
          width: 100
        },
        {
          title: '产品名称',
          key: 'productName',
          minWidth: 300,
          align: 'center'
        },
        {
          title: '档次',
          key: 'grade',
          minWidth: 80,
          align: 'center'
        },
        {
          title: '投保人',
          key: 'holderName',
          minWidth: 120,
          align: 'center'
        },
        {
          title: '保险期间',
          key: 'startTime',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            let startTime = params.row.startTime.substring(0, 10);
            let endTime = params.row.endTime.substring(0, 10);
            return (
              <span>
                {startTime || '-'} 至 {endTime || '-'}
              </span>
            );
          }
        },
        {
          title: '出单保费（元）',
          key: 'fee',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            return <span> {number_format(params.row.fee, 2)}</span>;
          }
        },
        {
          title: '出单服务费（元）',
          slot: 'commission',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            if (params.row.noCommissionReason) {
              return <span style="color: red"> {params.row.noCommissionReason}</span>;
            } else {
              return <span> {number_format(params.row.commission, 2)}</span>;
            }
          }
        },
        {
          title: '保单状态',
          key: 'status',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            return <span> {statusMap[params.row.status]}</span>;
          }
        },
        {
          title: '出单业务员',
          key: 'salemanName',
          minWidth: 230,
          align: 'center',
          render(h, params) {
            return (
              <span>
                {params.row.staffNo} /{params.row.salemanName}
              </span>
            );
          }
        },
        {
          title: '所属团队',
          key: 'groupName',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            return (
              <span>
                {params.row.organizationName} /{params.row.groupName}
              </span>
            );
          }
        }
      ];
      if (this.$units.isOkTX() || this.$units.isOkBao()|| this.$units.isRYBB()) {
        columns = columns.concat([
          {
            title: '推广执行人',
            slot: 'executer',
            align: 'center',
            minWidth: 100
          },
          {
            title: '推广渠道 ',
            slot: 'channel',
            align: 'center',
            minWidth: 100
          },
        ]);
      }
      if(this.$units.isOkBao() || this.$units.isRYBB()){
        columns = columns.concat([
          {
            title: '团险销售支持 ',
            width: '140',
            align: 'center',
            key: 'groupSalesSupport'
          }
        ]);
      }
      if(this.$units.showSupplier() && this.$units.pointAction('order_50_21')){
        columns = columns.concat([
          {
            title: '供应商 ',
            width: '140',
            align: 'center',
            key: 'supplierName'
          }
        ]);
      }
      columns = columns.concat([
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: '180',
          fixed: 'right'
        }
      ]);
      this.columns = columns;
    }
  }
};
